module.exports = __webpack_public_path__ + "static/img/QR-image.c43e11d5.png";